<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k3OFet/tc-custom/9781497647480.jpg?1734049006387" alt="This image is the cover for the book Reckoning"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reckoning
      </h1>
      <p class="bookDescription body article font2">
        <b>In this poignant novel by a <i>New York Times</i>–bestselling author, a dying woman looks back on the great relationships of her life.</b><br/><br/> When she learns that she is dying, Laura Spelman vows to spend her final year only on what matters most. As she quickly realizes, this means coming to terms with her most fruitful and important bonds—her “real connections”—all of which have been with women. From her tempestuous daughter and beloved aunt, to a promising lesbian writer she is mentoring and a cherished friend from her youth, Laura revisits her most significant relationships, each fraught with its own history and meaning.<br/><br/> Insightful and witty, <i>A Reckoning </i>is an unforgettable portrait of one woman’s journey to seize life before it ends, and of the power in embracing the fact that the most challenging interactions are often the most rewarding.<br/><br/> This ebook features an extended biography of May Sarton.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        May Sarton
      </h2>
      
      <p class="authorDescription body article">May Sarton (1912&ndash;1995) was born on May 3 in Wondelgem, Belgium, and grew up in Cambridge, Massachusetts. Her first volume of poetry,&#160;<i>Encounters in April</i>, was published in 1937 and her first novel,&#160;<i>The Single Hound</i>, in 1938.&#160;Her novels <i>A Shower of Summer Days</i>, <i>The Birth of a Grandfather</i>, and&#160;<i>Faithful Are the Wounds</i>, as well as her poetry collection&#160;<i>In Time Like Air</i>, all received&#160;nominations for the National Book Award.<BR><BR>An accomplished memoirist, Sarton came out as a lesbian in her 1965 book&#160;<i>Mrs. Stevens Hears the Mermaids Singing</i>. Her memoir&#160;<i>Journal of a Solitude&#160;</i>(1973) was an account of her experiences as a female artist.&#160;Sarton spent her later years in York, Maine, living and writing by the sea. In her last memoir,&#160;<i>Endgame: A Journal of the Seventy-Ninth Year</i>&#160;(1992), she shares her own personal thoughts on getting older. Her final poetry collection,&#160;<i>Coming into Eighty</i>, was published in 1994.&#160;Sarton died on July 16, 1995, in York, Maine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ec47976